import { ROLE_NAME } from '@shootsta/common-domain-data';

export default function isShootstaAccountManagerRoleName(roleName, status) {
  return ROLE_NAME.SHOOTSTA_AM === roleName && status === 'ACCEPTED';
}